import { ScatterChart } from "@mui/x-charts";
import * as React from "react";

export function ScatterPlot({ width, data }) {
  return (
    <ScatterChart
      width={width}
      height={width / 2}
      series={data.map((v) => ({
        label: v.id,
        data: [
          {
            x: v.x1,
            y: v.y1,
            id: v.id,
            size: v.size,
          },
        ],
        color: v.color,
        sizeKey: "size",
      }))}
    />
  );
}
